import React from 'react';
import PropTypes from 'prop-types';

export default class ServiceDialog extends React.Component {
  static contextTypes = {
    activateServiceDialog: PropTypes.func,
  };

  componentWillMount() {
    this.context.activateServiceDialog();
  }

  componentWillUnmount() {
    this.context.activateServiceDialog(false);
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Layout/StandardPageTemplate/Context/ServiceDialog.js